import { create } from 'zustand';
import { setLocaleSettings, type LocaleSettings } from '@/lib/localeFormatters';

interface LocaleStore {
  settings: LocaleSettings;
  updateSettings: (settings: Partial<LocaleSettings>) => void;
}

export const useLocaleStore = create<LocaleStore>((set) => ({
  settings: {
    dateFormat: 'DD.MM.YYYY',
    timeFormat: 'HH:mm',
    thousandsSeparator: '.',
    decimalSeparator: ',',
    currencySymbol: '\u20ac',
    currencyFormat: 'value_first',
  },
  updateSettings: (newSettings) => {
    set((state) => {
      const merged = { ...state.settings, ...newSettings };
      setLocaleSettings(merged);
      return { settings: merged };
    });
  },
}));
